import { Action } from '@ngrx/store';

import { UraniaCfg } from '@gosuite/urania-admin';


export const SELECT_URANIA_CFG = '[GO-SUITE:URANIA-ADMIN] SELECT_URANIA_CFG';


export class SelectUraniaCfg implements Action {
	readonly type = SELECT_URANIA_CFG;

	constructor(public payload: UraniaCfg) {}
}


export type All
	= SelectUraniaCfg;



// WEBPACK FOOTER //
// ./src/app/shared/state-management/actions/urania-admin.ts